import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class CkdataService {
  private suggestion$ = new BehaviorSubject<any>({});
  selectedProduct$ = this.suggestion$.asObservable();
  constructor() { }
  setSuggestion(suggests: any) {
    this.suggestion$.next(suggests);
  }
}
